import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Slider } from "@/components/ui/slider";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface WatermarkSettingsProps {
  enabled: boolean;
  onEnabledChange: (enabled: boolean) => void;
  position: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
  onPositionChange: (position: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right') => void;
  opacity: number;
  onOpacityChange: (opacity: number) => void;
  size: number;
  onSizeChange: (size: number) => void;
}

export const WatermarkSettings = ({
  enabled,
  onEnabledChange,
  position,
  onPositionChange,
  opacity,
  onOpacityChange,
  size,
  onSizeChange,
}: WatermarkSettingsProps) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <Label className="text-sm font-medium">Watermark</Label>
        <Switch checked={enabled} onCheckedChange={onEnabledChange} />
      </div>

      {enabled && (
        <>
          <div className="space-y-2">
            <Label className="text-xs">Position</Label>
            <Select value={position} onValueChange={onPositionChange}>
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="top-left">Top Left</SelectItem>
                <SelectItem value="top-right">Top Right</SelectItem>
                <SelectItem value="bottom-left">Bottom Left</SelectItem>
                <SelectItem value="bottom-right">Bottom Right</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <Label className="text-xs">Opacity</Label>
              <span className="text-xs text-muted-foreground">{Math.round(opacity * 100)}%</span>
            </div>
            <Slider
              value={[opacity * 100]}
              onValueChange={([value]) => onOpacityChange(value / 100)}
              min={0}
              max={100}
              step={5}
              className="w-full"
            />
          </div>

          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <Label className="text-xs">Size</Label>
              <span className="text-xs text-muted-foreground">{size}px</span>
            </div>
            <Slider
              value={[size]}
              onValueChange={([value]) => onSizeChange(value)}
              min={50}
              max={200}
              step={10}
              className="w-full"
            />
          </div>
        </>
      )}
    </div>
  );
};
